import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const DONATIONS_DONATION_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/donations',
        iconClass: 'fas fa-circle-dollar-to-slot',
        name: '::Menu:Donations',
        layout: eLayoutType.application,
        requiredPolicy: 'Mandir.Donations',
      },
    ]);
  };
}
